import i18n from '@/helpers/i18n';

export const CONSTANTS = {
    supportedLanguages: [ {"key": "pt", "label": i18n.t('portuguese')} ]
};
